export const TwilioRoomEvents = Object.freeze({
  Disconnected: 'disconnected',
  ParticipantConnected: 'participantConnected',
  ParticipantDisconnected: 'participantDisconnected',
  TrackPublished: 'trackPublished',
  TrackUnpublished: 'trackUnpublished',
  TrackSubscribed: 'trackSubscribed',
  TrackUnsubscribed: 'trackUnsubscribed',
  TrackEnabled: 'trackEnabled',
  TrackDisabled: 'trackDisabled',
  TrackMessage: 'trackMessage',
});

export const TwilioParticipantEvents = Object.freeze({
  TrackSubscribed: 'trackSubscribed',
  TrackUnsubscribed: 'trackUnsubscribed',
  TrackPublished: 'trackPublished',
  TrackDisabled: 'trackDisabled',
  TrackEnabled: 'trackEnabled',
});

export const TwilioTrackEvents = Object.freeze({
  Message: 'message',
});

export const TwilioTrackKind = Object.freeze({
  Video: 'video',
  Audio: 'audio',
  Data: 'data',
});
